var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOtherInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.106 1.83203C13.202 1.83203 14.61 3.26736 14.61 5.40336V11.534C14.61 13.6887 13.2453 15.09 11.1333 15.1034L6.00467 15.1054C3.90867 15.1054 2.5 13.67 2.5 11.534V5.40336C2.5 3.24803 3.86467 1.84736 5.97667 1.8347L11.1053 1.83203H11.106ZM11.106 2.83203L5.98 2.8347C4.428 2.84403 3.5 3.80403 3.5 5.40336V11.534C3.5 13.144 4.43667 14.1054 6.004 14.1054L11.13 14.1034C12.682 14.094 13.61 13.1327 13.61 11.534V5.40336C13.61 3.79336 12.674 2.83203 11.106 2.83203ZM10.9774 10.8145C11.2534 10.8145 11.4774 11.0385 11.4774 11.3145C11.4774 11.5905 11.2534 11.8145 10.9774 11.8145H6.16407C5.88807 11.8145 5.66407 11.5905 5.66407 11.3145C5.66407 11.0385 5.88807 10.8145 6.16407 10.8145H10.9774ZM10.9774 8.0235C11.2534 8.0235 11.4774 8.2475 11.4774 8.5235C11.4774 8.7995 11.2534 9.0235 10.9774 9.0235H6.16407C5.88807 9.0235 5.66407 8.7995 5.66407 8.5235C5.66407 8.2475 5.88807 8.0235 6.16407 8.0235H10.9774ZM8.00053 5.23896C8.27653 5.23896 8.50053 5.46296 8.50053 5.73896C8.50053 6.01497 8.27653 6.23897 8.00053 6.23897H6.16387C5.88787 6.23897 5.66387 6.01497 5.66387 5.73896C5.66387 5.46296 5.88787 5.23896 6.16387 5.23896H8.00053Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherInfo);
export default __webpack_public_path__ + "static/media/otherInfo.2231227b3424b146b5d5992b4b3c55c2.svg";
export { ForwardRef as ReactComponent };